import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Info } from 'react-feather';
import { getFullVersion, getBuildInfo, getEnvironmentDebugInfo } from '../../config/version';

const VersionBadge = () => {
  const buildInfo = getBuildInfo();
  const debugInfo = getEnvironmentDebugInfo();
  
  // Debug logging to help troubleshoot environment detection
  console.log('🔍 Version Badge Debug Info:', debugInfo);
  
  const versionTooltip = (
    <div>
      <div><strong>APL Ubil+</strong></div>
      <div><strong>Version:</strong> {buildInfo.version}</div>
      <div><strong>Build:</strong> {buildInfo.buildNumber}</div>
      <div><strong>Date:</strong> {buildInfo.buildDate}</div>
      <div><strong>Environment:</strong> {buildInfo.environment}</div>
    </div>
  );

  return (
    <Tooltip 
      arrow 
      title={versionTooltip}
      placement="bottom"
    >
      <Chip
        icon={<Info size={16} />}
        label={getFullVersion()}
        size="small"
        variant="outlined"
        style={{
          color: 'rgba(255, 255, 255, 0.8)',
          borderColor: 'rgba(255, 255, 255, 0.3)',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          fontSize: '0.75rem',
          height: '28px',
          padding: '0 8px',
          margin: '4px'
        }}
      />
    </Tooltip>
  );
};

export default VersionBadge;


